<template>
    <div class="site-list">
        <p class="site-list__text">
            {{ $t('Login with the same user to all our platforms:') }}
        </p>
        <div class="site-list__icons-container">
            <div class="site-list__list-item" v-for="site in sitesWithImages" :key="site.site_id">
                <a
                    class="site-list__link"
                    :class="{ 'site-list__link--disabled': !getSiteUrl(site) }"
                    v-sanitize-href="getSiteUrl(site)"
                    rel="noopener"
                    target="_blank"
                >
                    <div 
                        v-if="!site.imageUrl && site.localLogo" 
                        class="site-list__logo-container"
                        :class="{ 'site-list__logo-container--dark': site.name === 'Ecart API' }"
                    >
                        <img class="site-list__logo-icon" :src="site.localLogo" :alt="site.name" />
                    </div>
                    <img v-else-if="site.imageUrl" class="site-list__list-icon" :src="site.imageUrl" :alt="site.name" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppList',
    data() {
        return {
            siteUrls: {
                'Ecart Pay': 'https://ecartpay.com/',
                'Returns': 'https://returns.envia.com/',
                'Envia': 'https://envia.com/',
                'Fulfillment': 'https://fulfillment.envia.com/',
                'Partners': 'https://partners.envia.com/',
                'WMS': 'https://wms.envia.com/',
                'Ecart API': 'https://ecartapi.com/',
            },
            sitesWithLocalLogos: ['Ecart API'],
        };
    },
    computed: {
        ...mapGetters('ui', ['sites']),
        sitesWithImages() {
            const sitesWithImages = [];
            this.sites.forEach((site) => {
                let imageUrl = null;
                let localLogo = null;
                try {
                    imageUrl = require(`@/assets/images/icons/sites/${site.name.toLowerCase().replace(/ /g, '-')}.svg`);
                } catch (error) {
                    console.error(`Error fetching image for ${site.name}: ${error.message}`);
                }
                if (!imageUrl && this.sitesWithLocalLogos.includes(site.name)) {
                    try {
                        const logoFileName = site.name.toLowerCase().replace(/ /g, '');
                        localLogo = require(`@/assets/images/logos/${logoFileName}.svg`);
                    } catch (error) {
                        console.error(`Error fetching local logo for ${site.name}: ${error.message}`);
                    }
                }

                sitesWithImages.push({
                    ...site,
                    imageUrl,
                    localLogo,
                });
            });
            return sitesWithImages;
        },
    },
    methods: {
        getSiteUrl(site) {
            return this.siteUrls?.[site.name] || '';
        }
    }
};
</script>

<style lang="scss">
.site-list {
    margin: 30px 0;

    &__text {
        font-size: 0.9rem;
        font-weight: 500;
        color: $accounts-secondary-600;
        margin-bottom: 10px;
    }

    &__icons-container {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }

    &__list-item {
        flex-shrink: 0;
    }

    &__link {
        &--disabled {
            pointer-events: none;
        }
    }

    &__list-icon {
        height: 60px;
        width: 60px;
    }

    &__logo-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        background-color: #e8f0fa;
        border-radius: 14px;
        padding: 10px;

        &--dark {
            background-color: #000000;
        }
    }

    &__logo-icon {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>